exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-swipe .van-swipe-item[data-v-c925cb76] {\r\n  color: #fff;\r\n  font-size: 20px;\r\n  line-height: 150px;\r\n  text-align: center;\r\n  width:80%;\r\n  height:200px;\r\n  background-color: #39a9ed;\n}\n.sweiper[data-v-c925cb76] {\r\n  padding: 10px 15px;\r\n  color: #323233;\r\n  font-size: 0.37333rem;\n}\r\n", ""]);

// exports
